module.exports = __webpack_public_path__ + "5ccaaa632f17f9b8acccf3c8647c9731.MP3";